<template>
  <kpi-card :value="kpi?.sla" :maxWarningValue="kpi?.threshold" :maxDangerValue="kpi?.critical" :title="$t('home.abandoned_calls_rate')" unit="%" flipped/>
</template>

<script>
import KpiCard from "./KpiCard.vue";
export default {
  components: {
    KpiCard,
  },
  props: ["kpi"],
};
</script>

<style></style>
